const investmentTypeArticleLang = {
	article_6: {
		tag: 'investment.type.article.article_6',
		fr: 'Article 6',
		en: 'Article 6',
	},
	article_8: {
		tag: 'investment.type.article.article_8',
		fr: 'Article 8',
		en: 'Article 8',
	},
	article_9: {
		tag: 'investment.type.article.article_9',
		fr: 'Article 9',
		en: 'Article 9',
	},
	article_10: {
		tag: 'investment.type.article.article_10',
		fr: 'Article 10',
		en: 'Article 10',
	},
	article_6_short: {
		tag: 'investment.type.article.article_6_short',
		fr: 'Art. 6',
		en: 'Art. 6',
	},
	article_8_short: {
		tag: 'investment.type.article.article_8_short',
		fr: 'Art. 8',
		en: 'Art. 8',
	},
	article_9_short: {
		tag: 'investment.type.article.article_9_short',
		fr: 'Art. 9',
		en: 'Art. 9',
	},
	article_10_short: {
		tag: 'investment.type.article.article_10_short',
		fr: 'Art. 10',
		en: 'Art. 10',
	},
};

export default investmentTypeArticleLang;
